module.exports = __webpack_public_path__ + "img/investicon.af369850.svg";